<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->
      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Tipo de Veículo</span>
          <v-select
            :options="tipoFipe"
            name="Tipo"
            id="Tipo"
            v-model="tipoVeiculo"
            v-validate="{ required: true }"
            :state="validateState('Tipo')"
            :class="validateClass('Tipo')"
          ></v-select>
        </div>

        <div class="vx-col sm:w-1/3 w-full">
          <span>Marca</span>
          <v-select
            :options="marcas"
            name="Marca"
            id="Marca"
            v-model="marca"
            v-validate="{ required: true }"
            :state="validateState('Marca')"
            :class="validateClass('Marca')"
          ></v-select>
        </div>

        <div v-if="tipoCadastro == 'Modelo'" class="vx-col sm:w-1/3 w-full">
          <span>Modelo</span>
          <v-select
            :options="modelos"
            name="modelo"
            id="modelo"
            v-model="modelo"
            v-validate="{ required: true }"
            :state="validateState('Modelo')"
            :class="validateClass('Modelo')"
          ></v-select>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button color="success" class="mr-3 mb-2">Adicionar</vs-button>
        </div>
      </div>
    </form>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from './../../locale';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import service from '../../services';
import {decryptData} from '../../services/decryptData';
import {getTranslate} from "@/services/translate/translate";
import jwt from "jsonwebtoken";

export default {
  props: ['tipo', 'entidade', 'pk', 'tipoCadastro', 'idGrupo'],
  watch: {
    tipoVeiculo(value) {
      this.form.codigoTipoVeiculo = value.id;
      this.marca = null;
      this.buscaDadosMarcas();
    },
    marca(value) {
      this.form.codigoMarca = value.id;
      this.modelo = null;
      if (this.tipoCadastro == 'Modelo') this.buscaDadosModelos();
    },
    modelo(value) {
      this.form.codigoModelo = value.id;
    },
  },
  data() {
    return {
      aguardeCadastro: false,
      idEmpresa: null,
      marcas: [],
      modelos: [],
      tipoFipe: [],
      languages: lang,
      funcoesValicao: null,
      tipoVeiculo: null,
      marca: null,
      modelo: null,
      form: {
        codigoTabelaReferencia: null,
        codigoTipoVeiculo: null,
        codigoMarca: null,
        codigoModelo: null,
      },
      formCadastro: {
        idEmpresa: null,
        marca: null,
        modelo: null,
        idMarca: null,
        idModelo: null,
        idGrupo: null,
        idTipo: null,
        tipo: null,
      },
      ativaMascarasVeiculos: false,
    };
  },
  methods: {
    async translate() {
      if (!this.idEmpresa || !this.ativaMascarasVeiculos) return;
      const nameDefaultLocale = `default${this.idEmpresa}`;
      const translateDefault = await getTranslate(this.idEmpresa);
      if (translateDefault) {
        this.$i18n.setLocaleMessage(nameDefaultLocale, translateDefault);
        this.$i18n.locale = nameDefaultLocale;
      }
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        const decoded = jwt.decode(token);
        this.idEmpresa = decoded.id_empresa;
      }
    },
    async buscaDadosEmpresa() {
      try {
        this.$vs.loading();
        let {data} = await service.getAll(
          'g',
          {},
          `empresas/list/idEmpresa/${this.idEmpresa}`,
        );

        data = decryptData(data);

        const [resultEmpresa] = data;

        this.ativaMascarasVeiculos = resultEmpresa.ativaMascarasVeiculos;
      } catch (error) {
        this.erroConexao =
          'Seu aplicativo parece estar offline, verifique sua conexão';
        throw error;
      } finally {
        this.$vs.loading.close();
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },

    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data = decryptData(res.data);
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
            valeu: this.$t(element[campoDescricao], {msg: element[campoDescricao]}),
          });
        });
      });
    },
    buscaTiposFipe() {
      service.getAll('g', {}, `domTipoFipe/list/`).then((res) => {
        res.data = decryptData(res.data);

        res.data.forEach((element) => {
          this.tipoFipe.push({
            value: element.nomeTipo,
            id: element.idTipoFipe,
            label: this.$t(element.nomeTipo, {
              msg: element.nomeTipo
            }),
          });
        });
      });

      console.log(this.tipoFipe);
    },
    buscaUltimaTabelaFipe() {
      this.$vs.loading();
      service.post('Fipe', `ConsultarTabelaDeReferencia`, {}).then((res) => {
        this.form.codigoTabelaReferencia = res.data[0].Codigo;
        this.$vs.loading.close();
      });
    },
    buscaDadosMarcas() {
      this.$vs.loading();
      service.post('Fipe', `ConsultarMarcas`, this.form).then((res) => {
        const arr = res.data;
        arr.forEach((element) => {
          this.marcas.push({
            id: element.id ? element.id : element.value.id,
            label: element.name ? element.name : element.text,
          });
        });
        this.$vs.loading.close();
      });
    },
    buscaDadosModelos() {
      this.$vs.loading();
      service.post('Fipe', `ConsultarModelos`, this.form).then((res) => {
        const arr = res.data[0];
        arr.forEach((element) => {
          this.modelos.push({
            id: element.id,
            label: element.name,
          });
        });
        this.$vs.loading.close();
      });
    },
    onSubmit() {
      this.formCadastro.idEmpresa = this.idEmpresa;
      this.formCadastro.idGrupo = this.idGrupo;

      var action = 'Adicionar';
      var msgRetorno = 'Registro Adicionado com sucesso';
      if (this.marca) {
        this.formCadastro.marca = this.marca.label;
        this.formCadastro.idMarca = this.marca.id;
      }
      if (this.modelo) {
        this.formCadastro.modelo = this.modelo.label;
        this.formCadastro.idModelo = this.modelo.id;
      }
      if (this.tipoVeiculo) {
        this.formCadastro.tipo = this.tipoVeiculo.label;
        this.formCadastro.idTipo = this.tipoVeiculo.id;
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service
            .post(this.entidade, action, this.formCadastro)
            .then((res) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: `Operação Realizada com sucesso`,
                color: 'success',
              });
              this.$emit('add');
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: error,
                color: 'danger',
              });
            });
        }
      });
    },
  },
  async mounted() {
    this.getDecoded()
    this.buscaTiposFipe();
    await this.buscaDadosEmpresa();
    await this.translate();
    //this.buscaUltimaTabelaFipe();
    //this.buscaDadosSelects("domUf", "estados", "nomeUf", "codUf");
    //this.buscaDadosSelects("domMunicipio", "cidades", "nomeCidade", "idCidade");
    this.$validator.localize('ptBr', locale);
  },
  components: {
    Datepicker,
    'v-select': vSelect,
  },
};
</script>
<!------------ END SCRIPT ------------>
